export default "__VITE_ASSET__BBj27tb6__"